import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import config from '../../config/appConfig';

export default function ListaNegocios({ onNavigate, filtroEstado, onAuthError }) {
    const [negocios, setNegocios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');
    const [estadoFiltro, setEstadoFiltro] = useState(filtroEstado || '');
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [total, setTotal] = useState(0);

    const token = localStorage.getItem('superadmin_token');
    const authHeaders = { headers: { 'token': token, 'Content-Type': 'application/json' } };

    const cargarNegocios = useCallback(async () => {
        setLoading(true);
        try {
            const params = { page, limit: 20 };
            if (search) params.search = search;
            if (estadoFiltro) params.estado = estadoFiltro;

            const res = await axios.get(config.api_url + '/api/bimba/negocios', {
                ...authHeaders,
                params
            });

            if (res.data && res.data.status === "success") {
                setNegocios(res.data.data);
                setTotalPages(res.data.total_pages);
                setTotal(res.data.total);
            } else {
                toast.error(res.data.message || "Error al cargar");
            }
        } catch (err) {
            console.error(err);
            if (err.response && err.response.status === 401) {
                onAuthError();
                return;
            }
            toast.error(!err.response ? "No se pudo conectar con el servidor." : "Error de conexión");
        } finally {
            setLoading(false);
        }
    }, [page, search, estadoFiltro]);

    useEffect(() => {
        cargarNegocios();
    }, [cargarNegocios]);

    useEffect(() => {
        if (filtroEstado) {
            setEstadoFiltro(filtroEstado);
            setPage(1);
        }
    }, [filtroEstado]);

    const handleSearch = (e) => {
        e.preventDefault();
        setPage(1);
        cargarNegocios();
    };

    const handleCambiarEstado = async (negocioId, nuevoEstado) => {
        try {
            const res = await axios.put(
                `${config.api_url}/api/bimba/negocios/${negocioId}/estado`,
                { estado: nuevoEstado },
                authHeaders
            );
            if (res.data && res.data.status === "success") {
                toast.success(`Estado cambiado a ${nuevoEstado}`);
                cargarNegocios();
            } else {
                toast.error(res.data.message || "Error al cambiar estado");
            }
        } catch (err) {
            if (err.response && err.response.status === 401) {
                onAuthError();
                return;
            }
            toast.error(!err.response ? "No se pudo conectar con el servidor." : "Error al cambiar estado");
        }
    };

    const getEstadoStyle = (estado) => {
        switch (estado) {
            case 'AL_DIA': return { bg: '#e6faf5', color: '#10b981', label: 'Al Día', icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z' };
            case 'PENDIENTE': return { bg: '#fff8e6', color: '#f59e0b', label: 'Pendiente', icon: 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z' };
            case 'BLOQUEADA': return { bg: '#ffe6e6', color: '#ef4444', label: 'Bloqueada', icon: 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z' };
            default: return { bg: '#f3f4f6', color: '#6b7280', label: estado, icon: 'M12 9v2m0 4h.01' };
        }
    };

    return (
        <div style={{
            padding: '32px',
            maxWidth: '1200px',
            margin: '0 auto',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        }}>
            {/* HEADER */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                marginBottom: '24px'
            }}>
                <div>
                    <h1 style={{
                        fontSize: '28px',
                        fontWeight: '700',
                        color: '#1a1a2e',
                        margin: '0 0 8px',
                        letterSpacing: '-0.5px'
                    }}>Negocios</h1>
                    <p style={{ color: '#6b7280', fontSize: '14px', margin: 0 }}>
                        {total} negocio(s) registrado(s) en el sistema
                    </p>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                    <button onClick={() => onNavigate('nuevo')} style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        padding: '10px 20px',
                        background: '#1a1a2e',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '10px',
                        fontSize: '13px',
                        fontWeight: 600,
                        cursor: 'pointer'
                    }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                            <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
                        </svg>
                        Nuevo Negocio
                    </button>
                    <button onClick={cargarNegocios} style={{
                        padding: '10px',
                        background: '#fff',
                        border: '1.5px solid #e5e7eb',
                        borderRadius: '10px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="23 4 23 10 17 10"/>
                            <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
                        </svg>
                    </button>
                </div>
            </div>

            {/* FILTROS */}
            <div style={{
                background: '#fff',
                borderRadius: '14px',
                border: '1px solid #f3f4f6',
                padding: '16px 20px',
                marginBottom: '20px'
            }}>
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <div style={{ flex: 1, position: 'relative' }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                            style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)' }}>
                            <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                        </svg>
                        <form onSubmit={handleSearch}>
                            <input
                                type="text"
                                placeholder="Buscar por nombre..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                style={{
                                    width: '100%',
                                    padding: '10px 14px 10px 40px',
                                    border: '1.5px solid #e5e7eb',
                                    borderRadius: '10px',
                                    fontSize: '14px',
                                    outline: 'none',
                                    background: '#fff',
                                    boxSizing: 'border-box'
                                }}
                            />
                        </form>
                        {search && (
                            <button onClick={() => { setSearch(''); setPage(1); }} style={{
                                position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)',
                                background: 'none', border: 'none', cursor: 'pointer', padding: '4px'
                            }}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round">
                                    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                                </svg>
                            </button>
                        )}
                    </div>
                    <select value={estadoFiltro}
                        onChange={(e) => { setEstadoFiltro(e.target.value); setPage(1); }}
                        style={{
                            padding: '10px 14px',
                            border: '1.5px solid #e5e7eb',
                            borderRadius: '10px',
                            fontSize: '14px',
                            outline: 'none',
                            background: '#fff',
                            color: '#374151',
                            minWidth: '160px'
                        }}>
                        <option value="">Todos los estados</option>
                        <option value="AL_DIA">Al Día</option>
                        <option value="PENDIENTE">Pendiente</option>
                        <option value="BLOQUEADA">Bloqueada</option>
                    </select>
                    <span style={{ color: '#9ca3af', fontSize: '13px', whiteSpace: 'nowrap' }}>
                        Pág. {page} de {totalPages}
                    </span>
                </div>
            </div>

            {/* TABLA */}
            <div style={{
                background: '#fff',
                borderRadius: '14px',
                border: '1px solid #f3f4f6',
                overflow: 'hidden'
            }}>
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr style={{ background: '#f9fafb', borderBottom: '1px solid #f3f4f6' }}>
                                {['ID', 'Nombre', 'Estado', 'Inicio Servicio', 'POS', 'KDS', ''].map(h => (
                                    <th key={h} style={{
                                        padding: '14px 20px',
                                        textAlign: h === '' ? 'right' : 'left',
                                        fontSize: '12px',
                                        fontWeight: 600,
                                        color: '#6b7280',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px'
                                    }}>{h}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: 'center', padding: '60px 20px' }}>
                                        <div style={{
                                            width: '32px', height: '32px',
                                            border: '3px solid #e5e7eb', borderTopColor: '#667eea',
                                            borderRadius: '50%', animation: 'spin 0.6s linear infinite',
                                            margin: '0 auto 12px'
                                        }}/>
                                        <p style={{ color: '#6b7280', fontSize: '14px', margin: 0 }}>Cargando negocios...</p>
                                    </td>
                                </tr>
                            ) : negocios.length === 0 ? (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: 'center', padding: '60px 20px' }}>
                                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" strokeWidth="1.5" style={{ marginBottom: '12px' }}>
                                            <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
                                        </svg>
                                        <p style={{ color: '#9ca3af', fontSize: '14px', margin: 0 }}>No se encontraron negocios</p>
                                    </td>
                                </tr>
                            ) : (
                                negocios.map((neg) => {
                                    const es = getEstadoStyle(neg.estado_licencia);
                                    return (
                                        <tr key={neg.id} onClick={() => onNavigate('detalle', neg.id)}
                                            style={{ cursor: 'pointer', borderBottom: '1px solid #f3f4f6', transition: 'background 0.15s' }}>
                                            <td style={{ padding: '16px 20px' }}>
                                                <span style={{
                                                    background: '#f3f4f6',
                                                    color: '#6b7280',
                                                    padding: '4px 10px',
                                                    borderRadius: '6px',
                                                    fontSize: '12px',
                                                    fontWeight: 600
                                                }}>#{neg.id}</span>
                                            </td>
                                            <td style={{ padding: '16px 20px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                    <div style={{
                                                        width: '36px', height: '36px',
                                                        background: '#eef0ff',
                                                        borderRadius: '10px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#667eea" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                                            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                                                            <polyline points="9 22 9 12 15 12 15 22"/>
                                                        </svg>
                                                    </div>
                                                    <span style={{ fontWeight: 600, color: '#1a1a2e', fontSize: '14px' }}>{neg.nombre}</span>
                                                </div>
                                            </td>
                                            <td style={{ padding: '16px 20px' }}>
                                                <span style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    gap: '6px',
                                                    padding: '6px 12px',
                                                    background: es.bg,
                                                    color: es.color,
                                                    borderRadius: '8px',
                                                    fontSize: '12px',
                                                    fontWeight: 600
                                                }}>
                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                        <path d={es.icon}/>
                                                    </svg>
                                                    {es.label}
                                                </span>
                                            </td>
                                            <td style={{ padding: '16px 20px', color: '#6b7280', fontSize: '13px' }}>
                                                {neg.fecha_corte_pago || <span style={{ fontStyle: 'italic', color: '#d1d5db' }}>Sin fecha</span>}
                                            </td>
                                            <td style={{ padding: '16px 20px' }}>
                                                <span style={{
                                                    background: '#eef0ff',
                                                    color: '#667eea',
                                                    padding: '4px 10px',
                                                    borderRadius: '6px',
                                                    fontSize: '12px',
                                                    fontWeight: 600
                                                }}>{neg.cantidad_pos || 0}</span>
                                            </td>
                                            <td style={{ padding: '16px 20px' }}>
                                                <span style={{
                                                    background: '#f3f4f6',
                                                    color: '#6b7280',
                                                    padding: '4px 10px',
                                                    borderRadius: '6px',
                                                    fontSize: '12px',
                                                    fontWeight: 600
                                                }}>{neg.cantidad_kds || 0}</span>
                                            </td>
                                            <td style={{ padding: '16px 20px', textAlign: 'right' }}>
                                                <div style={{ position: 'relative', display: 'inline-block' }}>
                                                    <button onClick={(e) => {
                                                        e.stopPropagation();
                                                        const menu = e.currentTarget.nextElementSibling;
                                                        menu.style.display = menu.style.display === 'block' ? 'none' : 'block';
                                                    }} style={{
                                                        padding: '8px',
                                                        background: '#fff',
                                                        border: '1.5px solid #e5e7eb',
                                                        borderRadius: '8px',
                                                        cursor: 'pointer',
                                                        display: 'flex'
                                                    }}>
                                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round">
                                                            <circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/>
                                                        </svg>
                                                    </button>
                                                    <div style={{
                                                        display: 'none',
                                                        position: 'absolute',
                                                        right: 0,
                                                        top: '100%',
                                                        marginTop: '4px',
                                                        background: '#fff',
                                                        border: '1px solid #e5e7eb',
                                                        borderRadius: '10px',
                                                        boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
                                                        zIndex: 50,
                                                        minWidth: '180px',
                                                        overflow: 'hidden'
                                                    }}>
                                                        <button onClick={(e) => { e.stopPropagation(); onNavigate('detalle', neg.id); }}
                                                            style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%', padding: '10px 16px', border: 'none', background: 'none', cursor: 'pointer', fontSize: '13px', color: '#374151' }}>
                                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                                                            Ver Detalle
                                                        </button>
                                                        <div style={{ height: '1px', background: '#f3f4f6', margin: '4px 0' }}/>
                                                        <button onClick={(e) => { e.stopPropagation(); handleCambiarEstado(neg.id, 'AL_DIA'); }}
                                                            style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%', padding: '10px 16px', border: 'none', background: 'none', cursor: 'pointer', fontSize: '13px', color: '#10b981' }}>
                                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
                                                            Marcar Al Día
                                                        </button>
                                                        <button onClick={(e) => { e.stopPropagation(); handleCambiarEstado(neg.id, 'PENDIENTE'); }}
                                                            style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%', padding: '10px 16px', border: 'none', background: 'none', cursor: 'pointer', fontSize: '13px', color: '#f59e0b' }}>
                                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
                                                            Marcar Pendiente
                                                        </button>
                                                        <button onClick={(e) => { e.stopPropagation(); handleCambiarEstado(neg.id, 'BLOQUEADA'); }}
                                                            style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%', padding: '10px 16px', border: 'none', background: 'none', cursor: 'pointer', fontSize: '13px', color: '#ef4444' }}>
                                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                                                            Bloquear
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* PAGINACIÓN */}
            {totalPages > 1 && (
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '24px' }}>
                    <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                        <button disabled={page <= 1} onClick={() => setPage(p => Math.max(1, p - 1))}
                            style={{
                                padding: '8px 12px',
                                border: '1.5px solid #e5e7eb',
                                borderRadius: '8px',
                                background: '#fff',
                                cursor: page <= 1 ? 'not-allowed' : 'pointer',
                                opacity: page <= 1 ? 0.5 : 1
                            }}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#374151" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>
                        </button>
                        {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
                            <button key={p} onClick={() => setPage(p)}
                                style={{
                                    padding: '8px 14px',
                                    border: p === page ? 'none' : '1.5px solid #e5e7eb',
                                    borderRadius: '8px',
                                    background: p === page ? '#1a1a2e' : '#fff',
                                    color: p === page ? '#fff' : '#374151',
                                    fontWeight: p === page ? 600 : 400,
                                    cursor: 'pointer',
                                    fontSize: '13px'
                                }}>{p}</button>
                        ))}
                        <button disabled={page >= totalPages} onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                            style={{
                                padding: '8px 12px',
                                border: '1.5px solid #e5e7eb',
                                borderRadius: '8px',
                                background: '#fff',
                                cursor: page >= totalPages ? 'not-allowed' : 'pointer',
                                opacity: page >= totalPages ? 0.5 : 1
                            }}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#374151" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
                        </button>
                    </div>
                </div>
            )}

            <style>{`
                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
                tbody tr:hover {
                    background: #f9fafb;
                }
            `}</style>
        </div>
    );
}
